import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userId: null,
  userName: null,
  userEmail: null,
  accessToken: null,
  refreshToken: null,
  userRole: null,
  companyCode: null,
  companyLogo: null,
  companyProfile: null,
  accessLevel: null,
  isActivated: null,
  userProfilePicture: null,
   profileId: null, 
   isDeletedAccess: null,
forcePassword: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      Object.assign(state, action.payload);
    },

    updateAccessToken: (state, action) => {
      state.accessToken = action.payload;
    },

    logout: () => ({ ...initialState }),
  },
});

export const { setUser, updateAccessToken, logout } = userSlice.actions;
export default userSlice.reducer;
